import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import BootstrapTable from "react-bootstrap-table-next";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getCategories, getPartyApi, getUnitAPI, getUserApi, updateExpressInward, addDataEntryOutwards } from "api";
import OutwardFormModal from "../Common/OutwardFormModal";

const defaultSorted = [
  { dataField: "id", order: "asc" },
];

const columns1 = [
  { dataField: "dateTime", text: "Date & Time", sort: true },
  { dataField: "deliveryBoy", text: "Delivery Boy", sort: true },
  { dataField: "pieces", text: "Pieces", sort: true },
  { dataField: "cts.", text: "Cts", sort: true },
  { dataField: "remarks", text: "Remarks" },
  { dataField: "action", text: "Action" },
];
const columns2 = [
  { dataField: "dateTime", text: "Date & Time", sort: true },
  { dataField: "deliveryBoy", text: "Delivery Boy", sort: true },
  { dataField: "pieces", text: "Pieces", sort: true },
  { dataField: "cts.", text: "Cts", sort: true },
  { dataField: "remarks", text: "Remarks" },
];

// Dummy data for Returned table
const returnedDummyData = [
  {
    id: 1,
    dateTime: "2024-06-01 10:00",
    deliveryBoy: "John Doe",
    pieces: 5,
    "cts.": 1.23,
    remarks: "Sample remark 1",
  },
  {
    id: 2,
    dateTime: "2024-06-02 11:30",
    deliveryBoy: "Jane Smith",
    pieces: 3,
    "cts.": 0.98,
    remarks: "Sample remark 2",
  },
];

class AcceptExpressInward extends Component {
  constructor(props) {
    
    console.log('rr',props.location?.query);
    super(props);
    this.state = {
      partyList: [],
      factoryList: [],
      categoryList: [],
      deliveryBoyList: [],
      stockList: [],
      props: props.location?.query || { isEdit: 3, data: null },
      isReturnAndAccept: false,
      isModalOpen: false,
    };
  }

  async componentDidMount() {
    console.log('rr',this.state.props.data);

    const categories = await getCategories();
    const party = await getPartyApi({ page: null, limit: null, name: null, partyCode: null });
    const factory = await getUnitAPI({ isInternal: null });
    const deliveryBoy = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000006",
    });
    this.setState({
      partyList: party.data.parties,
      factoryList: factory.data.factories,
      categoryList: categories.data,
      deliveryBoyList: deliveryBoy.data.users,
    });
  }

  render() {
    document.title = "sales-office";
    const { props } = this.state;
    const data = props.data || {};
    const mainJangad = data.mainJangad || {};
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={`${this.props.t("EXPRESS - INWARD")}`} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block justify-content-between">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {this.props.t("View Express (Inward)")}
                        </h4>
                      </div>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        jangadId:this.state.props.data.jangadId,
                        name: mainJangad.name,
                        partyJangadNo: mainJangad.partyJangadNo,
                        partyId: mainJangad.partyId,
                        partyCode: mainJangad.partyId,
                        categoryId: mainJangad.categoryId,
                        factoryId: data.factoryId || "Sayan",
                        weight: data.weight,
                        pieces: data.pieces,
                        fromDeliverBoyId: data.fromDeliverBoyId,
                        cycle: 1,
                        remarks: data.remarks,
                        nextRemarks: data.nextRemarks || "",
                      }}
                      onSubmit={() => {}}
                    >
                      {({ errors, touched }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="col-xl-8 col-12">
                              {/* Jangad Id */}
                              <div className="mb-3 row">
                                <Label htmlFor="name" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Jangad Id")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    disabled
                                    type="text"
                                    name="name"
                                    value={this.state.props.data.jangadId}
                                    placeholder="JANGAD0000123"
                                  />
                                </div>
                              </div>
                              {/* Party Name */}
                              <div className="mb-3 row">
                                <Label htmlFor="partyId" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Party")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    name="partyId"
                                    as="select"
                                    disabled
                                  >
                                    <option value="" disabled>select</option>
                                    {this.state.partyList?.map(x => (
                                      <option key={x.id} value={x.id}>{x.partyCode} - {x.name}</option>
                                    ))}
                                  </Field>
                                </div>
                              </div>
                              {/* Diamond Category */}
                              <div className="mb-3 row">
                                <Label htmlFor="categoryId" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Diamond Category")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    name="categoryId"
                                    as="select"
                                    disabled
                                  >
                                    <option value="" disabled>Select</option>
                                    {this.state.categoryList?.map(x => (
                                      <option key={x.id} value={x.id}>{x.name}</option>
                                    ))}
                                  </Field>
                                </div>
                              </div>
                              {/* Unit Name */}
                              <div className="mb-3 row">
                                <Label htmlFor="factoryId" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Unit Name")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    name="factoryId"
                                    as="select"
                                    disabled
                                  >
                                    <option value="" disabled>select</option>
                                    {this.state.factoryList?.map(x => (
                                      <option value={x.id} key={x.id}>{x.name}</option>
                                    ))}
                                  </Field>
                                </div>
                              </div>
                              {/* Total No of pieces */}
                              <div className="mb-3 row">
                                <Label htmlFor="pieces" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Total No of pieces")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    min="0"
                                    type="number"
                                    name="pieces"
                                    placeholder="No. of peices"
                                    value={this.state.props.data.noOfPieces}
                                    readOnly
                                  />
                                </div>
                              </div>
                              {/* Total Weight */}
                              <div className="mb-3 row">
                                <Label htmlFor="weight" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Total Weight")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    type="number"
                                    name="weight"
                                    placeholder="Total Weight"
                                    value={this.state.props.data.totalWeight}
                                    readOnly
                                  />
                                </div>
                              </div>
                              {/* Delivery Boy Name */}
                              <div className="mb-3 row">
                                <Label htmlFor="fromDeliverBoyId" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Delivery Boy Name")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    name="fromDeliverBoyId"
                                    as="select"
                                    disabled
                                  >
                                    <option value="" disabled>select</option>
                                    {this.state.deliveryBoyList?.map(x => (
                                      <option key={x.id} value={x.id}>{x.name}</option>
                                    ))}
                                  </Field>
                                </div>
                              </div>
                              {/* Cycle */}
                              <div className="mb-3 row">
                                <Label htmlFor="cycle" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Cycle")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    type="number"
                                    name="cycle"
                                    readOnly
                                    placeholder="1"
                                    value={this.state.props.data.cycle}
                                  />
                                </div>
                              </div>
                              {/* Seles Person Remarks */}
                              <div className="mb-3 row">
                                <Label htmlFor="remarks" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Seles Person Remarks")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    type="text"
                                    name="remarks"
                                    as="textarea"
                                    rows="5"
                                    disabled
                                    value={this.state.props.data.salesRemark}
                                  />
                                </div>
                              </div>
                              {/* No Of Pieces Delivered */}
                              <div className="mb-3 row">
                                <Label htmlFor="noOfPiecesDelivered" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("No Of Pieces Delivered")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    type="number"
                                    name="noOfPiecesDelivered"
                                    readOnly
                                    placeholder="1"
                                    value={this.state.props.data.deliveredPieces}
                                  />
                                </div>
                              </div>
                              {/* Total Cts Delivered */}
                              <div className="mb-3 row">
                                <Label htmlFor="totalCtsDelivered" className="col-md-2 col-form-label">
                                  <h5 className="text-secondary fw-bold">{this.props.t("Total Cts Delivered")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className="form-control fs-5"
                                    type="number"
                                    name="totalCtsDelivered"
                                    readOnly
                                    placeholder="1"
                                    value={this.state.props.data.deliveredWeight}
                                  />
                                </div>
                              </div>
                              {/* Outward Table */}
                              <div className="row px-3 pt-4">
                                <div>
                                  <h3 className="fw-bold pb-3 text-black">{this.props.t(" Outward")}</h3>
                                </div>
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    data={this.state.stockList || []}
                                    columns={columns1}
                                    bootstrap4
                                    defaultSorted={defaultSorted}
                                    headerClasses="background-light fs-5"
                                    footerClasses="background-light fs-5"
                                  />
                                </div>
                              </div>
                              {/* Returned Table */}
                              <div className="row px-3 pt-4">
                                <div>
                                  <h3 className="fw-bold pb-3 text-black">{this.props.t(" Returned")}</h3>
                                </div>
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    data={returnedDummyData}
                                    columns={columns2}
                                    bootstrap4
                                    defaultSorted={defaultSorted}
                                    headerClasses="background-light fs-5"
                                    footerClasses="background-light fs-5"
                                    classes="foo"
                                  />
                                </div>
                              </div>
                            </div>
                            {/* Contact Info */}
                            <div className="col-xl-4 mb-2 col-12">
                              <div className="px-4">
                                <div className="row border-gray py-3">
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Contact Person")} :</h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      {this.state.props.data.party?.name}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Mobile no.1")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      +91 {this.state.props.data.party?.mobileNo1}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Mobile no.2")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      +91 {this.state.props.data.party?.mobileNo2}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Email Address")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      {this.state.props.data.party?.email}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* Action Buttons */}
                            <div className="col-md-12 text-end">
                              <button
                                type="button"
                                className="btn btn-primary fs-4 px-5 ms-3"
                                onClick={() => this.setState({ isReturnAndAccept: true })}
                              >
                                {this.props.t("Return & Accept")}
                              </button>
                              {this.state.props.data.status !== true && (
                                <button
                                  type="button"
                                  className="btn btn-primary fs-4 px-5 ms-3"
                                  onClick={() => this.props.history?.goBack?.()}
                                >
                                  {this.props.t("Accept Full")}
                                </button>
                              )}
                              {this.state.props.data.status == true && (
                              <button
                                type="button"
                                className="btn btn-primary fs-4 px-5 ms-3"
                                onClick={() => this.setState({ isModalOpen: true })}
                              >
                                {this.props.t("Outward")}
                              </button>
                              )}
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        {/* Return & Accept Modal */}
        <Modal isOpen={this.state.isReturnAndAccept} toggle={() => this.setState({ isReturnAndAccept: false })} centered>
          <ModalHeader toggle={() => this.setState({ isReturnAndAccept: false })}>
            {this.props.t("Return & Accept")}
          </ModalHeader>
          <ModalBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                id: String(this.state.props.data.id),
                noOfPieces: this.state.props.data.noOfPieces || "",
                noOfReturnedPiecesWithoutProcessed: this.state.props.data.noOfReturnedPiecesWithoutProcessed || "",
                totalWeight: this.state.props.data.totalWeight || "",
                salesRemark: this.state.props.data.salesRemark || "",
                deliveryBoyName: this.state.props.data.deliveryBoyName || "",
                dataEntryAcceptedAt: null,
              }}
              onSubmit={async (values) => {
                // Always include the correct id and log the payload
                const payload = {
                  id: String(this.state.props.data.id),
                  ...values,
                  noOfCompletedPieces: Number(values.noOfPieces || 0) - Number(values.noOfReturnedPiecesWithoutProcessed || 0),
                  status: true, // Ensure status is set to true on Return & Accept
                };
                console.log('Submitting Return & Accept payload:', payload);
                try {
                  await updateExpressInward(payload);
                  this.setState({ isReturnAndAccept: false });
                  if (this.props.refreshList) this.props.refreshList();
                } catch (err) {
                  console.error('Error updating express inward:', err);
                  // Optionally show error to user
                }
              }}
            >
              {({ handleSubmit, values, handleChange }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="mb-3 d-flex align-items-center">
                    <Label htmlFor="totalPieces" style={{ minWidth: 180 }} className="me-3">
                      <h5 className="text-secondary fw-bold">{this.props.t("Total Pieces")}</h5>
                    </Label>
                    <Field
                      type="number"
                      name="noOfPieces"
                      className="form-control w-50"
                      placeholder="Total Pieces"
                      value={values.noOfPieces}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center">
                    <Label htmlFor="noOfPiecesReturn" style={{ minWidth: 180 }} className="me-3">
                      <h5 className="text-secondary fw-bold">{this.props.t("No. of Pieces Return")}</h5>
                    </Label>
                    <Field
                      type="number"
                      name="noOfReturnedPiecesWithoutProcessed"
                      className="form-control w-50"
                      placeholder="No. of Pieces Return"
                      value={values.noOfReturnedPiecesWithoutProcessed}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center">
                    <Label htmlFor="cts" style={{ minWidth: 180 }} className="me-3">
                      <h5 className="text-secondary fw-bold">{this.props.t("Cts")}</h5>
                    </Label>
                    <Field
                      type="number"
                      name="weight"
                      className="form-control w-50"
                      placeholder="Cts"
                      value={values.weight}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center">
                    <Label htmlFor="remark" style={{ minWidth: 180 }} className="me-3">
                      <h5 className="text-secondary fw-bold">{this.props.t("Remark")}</h5>
                    </Label>
                    <Field
                      type="text"
                      name="salesRemark"
                      className="form-control w-50"
                      placeholder="Remark"
                      as="textarea"
                      rows="3"
                      value={values.salesRemark}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center">
                    <Label htmlFor="deliveryBoy" style={{ minWidth: 180 }} className="me-3">
                      <h5 className="text-secondary fw-bold">{this.props.t("Delivery Boy")}</h5>
                    </Label>
                    <Field
                      as="select"
                      name="deliveryBoyName"
                      className="form-control w-50"
                      value={values.deliveryBoyName }
                      onChange={handleChange}
                    >
                      <option value="" disabled>{this.props.t("Select")}</option>
                      {this.state.deliveryBoyList?.map(boy => (
                        <option key={boy.id} value={boy.id}>{boy.name}</option>
                      ))}
                    </Field>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-primary" type="submit">
                      {this.props.t("Submit")}
                    </button>
                    <button className="btn btn-secondary" type="button" onClick={() => this.setState({ isReturnAndAccept: false })}>
                      {this.props.t("Cancel")}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
        {/* Outward Modal */}
        <OutwardFormModal
          isOpen={this.state.isModalOpen}
          toggle={() => this.setState({ isModalOpen: false })}
          deliveryBoyList={this.state.deliveryBoyList}
          t={this.props.t}
          onSubmit={async (values, actions) => {
            // Prepare payload for addDataEntryOutwards with required fields
            const payload = {
              inwardId: this.state.props.data?.id, // required
              deliveryBoyName: values.deliveryBoy, // selected delivery boy id
              noOfPieces: values.piecesToDeliver, // pieces to deliver
              totalWeight: values.totalWeight, // optional, if required by API
              remark: values.remark, // optional
            };
            console.log('payload',payload);
            try {
              await addDataEntryOutwards(payload);
              this.setState({ isModalOpen: false });
              if (this.props.refreshList) this.props.refreshList();
            } catch (err) {
              console.error('Error submitting outward:', err);
              // Optionally show error to user
            }
          }}
          initialValues={{
            piecesToDeliver: "",
            totalWeight: "",
            remark: "",
            deliveryBoy: "",
          }}
        />
      </React.Fragment>
    );
  }
}
export default withTranslation()(AcceptExpressInward);
